module.exports = __webpack_public_path__ + "static/media/Roboto-Regular-webfont.3a7c47cb.ttf";